import { PurchaseEligibility } from 'app/api/@generated/backend';

import {
    selectSelectedAccountOrThrow,
    selectSelectedServiceLocationOrThrow,
} from 'app/pages/order/redux/order-selector';
import { PurchaseEligibilityService } from 'app/pages/order/services/purchase-eligibility-service';
import { createAppAsyncThunk } from 'app/redux/utils/thunk-utils';
import { RequestType } from 'app/pages/order/redux/model/order-request';
import { DataLayerErrorType } from 'app/data-layers/model/data-layer-error-type';
import { assertNotNil } from 'app/utils/type-utils';
import { pushErrorEvent } from 'app/data-layers/events/push-error-event';

export const fetchPurchaseEligibilityActionCreator = createAppAsyncThunk<PurchaseEligibility>(
    'order/fetchPurchaseEligibility',
    async (_, { getState }) => {
        const rootState = getState();

        const { customerId, partnerId } = selectSelectedAccountOrThrow(rootState);
        const { integrationId } = selectSelectedServiceLocationOrThrow(rootState);

        assertNotNil(customerId, 'Invalid state customer must be selected');
        assertNotNil(partnerId, 'Invalid state, partner information must be present');
        assertNotNil(integrationId, 'Invalid state, service location must be selected');

        const purchaseEligibility = await PurchaseEligibilityService.getPurchaseEligibility(
            partnerId,
            customerId,
            integrationId,
        );

        if (purchaseEligibility.isInDebt) {
            pushErrorEvent(true, DataLayerErrorType.DUNNING_ERROR, partnerId);
        }

        return purchaseEligibility;
    },
    {
        getPendingMeta: () => ({ requestType: RequestType.GET_PURCHASE_ELIGIBILITY }),
    },
);
